import { Component, OnInit, Input } from '@angular/core';
import SimuladorBase from '../../../base/SimuladorBase';
import { ProposalsAPI } from '../../../api/proposals.api';
import { Router } from '@angular/router';

@Component({
    selector: 'table-parcelas',
    templateUrl: './table-parcelas.component.html',
    styleUrls: ['./table-parcelas.component.scss']
})
export class TableParcelasComponent implements OnInit {

    @Input() simulacao: SimuladorBase;
    @Input() idProposta: number;
    public dadosSimulacao: Array<any> = [];

    public loading: boolean;

    //var de controle para não fica chamando em todo evento
    public totalEncargos: number = 0;
    //var de controle para não fica chamando em todo evento
    public parcelasAnuais: Array<any> = [];

    constructor(private ProposalsAPI: ProposalsAPI, public router: Router) { }

    private __maskPhone(input) {
        if (input.length <= 10) {
            input = input.replace(/^(\d{0,2})(\d{0,4})(\d.*)/, '($1) $2-$3');
        } else {
            input = input.replace(/^(\d{0,2})(\d{0,5})(\d.*)/, '($1) $2-$3');
        }

        return input;
    }

    async ngOnInit() {

        if (this.simulacao) {

            this.parcelasAnuais = Object.assign([], this.simulacao.getParcelaAnual());

            if (this.router.url.indexOf('simulations') >= 0) {

                // this.loading = true;

                let proposta = await this.ProposalsAPI.setForm(this.idProposta);
                
                if (proposta && proposta.Usuarios.length) {
                    let usuario = proposta.Usuarios[0];

                    this.dadosSimulacao.push(
                        {
                            label: 'Nome: ',
                            value: usuario.Nome
                        },
                        {
                            label: 'Data de nascimento: ',
                            value: this.simulacao.dtNascimento,
                            type: 'date'
                        },
                        {
                            label: 'Telefone: ',
                            value: this.__maskPhone(usuario.Telefone)
                        },
                        {
                            label: 'E-mail: ',
                            value: usuario.Email
                        },
                        {
                            label: 'Tipo do Imóvel: ',
                            value: this.simulacao.tipoImovel === 'R' ? 'Residencial' : 'Comercial'
                        }
                    );
                }

                let statusLine = {
                    label: 'Status do Imóvel: ',
                    value: undefined
                };

                switch (this.simulacao.statusImovel) {
                    case 'P':
                        statusLine.value = 'Imóvel pronto'
                        break;
                    case 'C':
                        statusLine.value = 'Em construção';
                        this.dadosSimulacao.push({
                            label: 'Tempo para terminar: ',
                            value: this.simulacao['tempoConstrucao']
                        });
                        break;
                    case 'I':
                        statusLine.value = 'Ainda não sei';
                        break;
                }

                if (statusLine.value)
                    this.dadosSimulacao.push(statusLine);

                if (this.simulacao['valorImovel'])
                    this.dadosSimulacao.push({ label: 'Valor do imóvel: ', value: this.simulacao['valorImovel'], type: 'money' });
                if (this.simulacao['renda'])
                    this.dadosSimulacao.push({ label: 'Renda: ', value: this.simulacao['renda'], type: 'money' });

                // this.loading = false;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/table-parcelas/table-parcelas.component.ts